module.exports = __webpack_public_path__ + "img/winerackdog20.fb9a3de3.jpg";